"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUARANTEED_BEAT_CREDIT_AMOUNT_DOLLARS = exports.UCC_APR_BEAT_BY_VALUE = exports.UCC_APR_BEAT_BY_VALUE_DECIMAL = void 0;
const interestRate_1 = require("./interestRate");
// The amount by which we guarantee to beat the competitor's APR in decimal form (i.e. 5% = 0.05)
exports.UCC_APR_BEAT_BY_VALUE_DECIMAL = 0.05;
exports.UCC_APR_BEAT_BY_VALUE = new interestRate_1.InterestRateDiscount({ units: interestRate_1.InterestRateUnits.decimal, aprAsDecimal: exports.UCC_APR_BEAT_BY_VALUE_DECIMAL });
// The amount of the credit we guarantee to give if we can't beat the competitor's APR
exports.GUARANTEED_BEAT_CREDIT_AMOUNT_DOLLARS = 250;
